import { InductionConfiguration, InductionQuizConfiguration } from "../TypesOrInterfaces/induction";
import { NESTLE_ID, VIVER_ADIUM_ID, quizCaregiverHidden } from "./aliasHidden";

export const acceptanceTermQuestionAliases = [
    "question_accepted_term",
    "question_late-term_acceptance"
];

export const prescriberStateAliases = [
    "question_prescriber_state",
    "question_prescriber_state_not_validation"
];

export const prescriberCrmAliases = [
    "question_prescriber_crm",
    "question_prescriber_crm_not_validation"
];

export const prescriberNameAliases = [
    "question_prescriber_name",
    "question_prescriber_name_not_validation"
];

function normalizeName(value?: string) {
    return (value || "").toLowerCase().replaceAll(" ", "");
}

// Quizzes que devem ser respondidos dentro do formulário do beneficiário (sem a tela "Adesão ao medicamento")
const quizMovedToFormNameByBenefitId: Record<number, string> = {
    [NESTLE_ID]: "nestlequiz",
    [VIVER_ADIUM_ID]: "adiumquiz",
};

// Ordem de exibição das perguntas do quiz movido, quando difere do `order` da configuração do plano
const movedQuizQuestionPriorityByBenefitId: Record<number, string[]> = {
    [VIVER_ADIUM_ID]: [
        "question_select_medicine",
        "question_prescriber_state",
        "question_prescriber_crm",
        "question_prescriber_name",
    ],
};

export function getMovedQuizQuestionPriority(benefitId?: number): string[] {
    return (benefitId !== undefined && movedQuizQuestionPriorityByBenefitId[benefitId]) || [];
}

export function getQuizMovedToBeneficiaryForm(
    configuration: InductionConfiguration,
    benefitId?: number
): InductionQuizConfiguration | undefined {
    if (!configuration.quiz) {
        return undefined;
    }

    const movedQuizName = benefitId !== undefined ? quizMovedToFormNameByBenefitId[benefitId] : undefined;

    return configuration.quiz.find(
        quiz => quiz.questions.some(question => quizCaregiverHidden.includes(question.questionAlias.toLocaleLowerCase()))
    ) || (
        movedQuizName
            ? configuration.quiz.find(quiz => normalizeName(quiz.name) === movedQuizName)
            : undefined
    );
}

export function isQuizMovedToBeneficiaryForm(
    quiz: InductionQuizConfiguration,
    movedQuiz?: InductionQuizConfiguration
) {
    return !!movedQuiz
        && quiz.id === movedQuiz.id
        && quiz.configurationId === movedQuiz.configurationId;
}

export function hasQuizQuestionsOutsideBeneficiaryForm(
    configuration: InductionConfiguration,
    benefitId?: number
) {
    const movedQuiz = getQuizMovedToBeneficiaryForm(configuration, benefitId);

    return configuration.quiz?.some(quiz => {
        if (isQuizMovedToBeneficiaryForm(quiz, movedQuiz)) {
            return false;
        }

        return quiz.questions.some(
            question => !acceptanceTermQuestionAliases.includes(question.questionAlias.toLowerCase())
        );
    }) || false;
}
